/* tslint:disable */
/* eslint-disable */
/* @relayHash 3001d4cf0be437a89369a28fa57129bd */

import { ConcreteRequest } from "relay-runtime";
export type CountryDropdownRendererQueryVariables = {};
export type CountryDropdownRendererQueryResponse = {
    readonly viewer: {
        readonly geography: {
            readonly countries: ReadonlyArray<{
                readonly abbreviation: string | null;
                readonly name: string | null;
            } | null> | null;
        } | null;
    };
};
export type CountryDropdownRendererQuery = {
    readonly response: CountryDropdownRendererQueryResponse;
    readonly variables: CountryDropdownRendererQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "geography",
  "storageKey": null,
  "args": null,
  "concreteType": "Geography",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "countries",
      "storageKey": null,
      "args": null,
      "concreteType": "GeographyObject",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "abbreviation",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CountryDropdownRendererQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "CountryDropdownRendererQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "CountryDropdownRendererQuery",
    "id": "app-buyer-trade/267.0.0-2020-06-02T16:23:38.038Z/CountryDropdownRendererQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = 'e91f505ab06f0c98a18211bb4605f78a';
export default node;
